<template>
  <section>
    <nav class="columns">
      <div class="column">
        <b-field grouped group-multiline>
          <b-field>
            <b-input
              v-model="searchName"
              :placeholder="$t('attributes.search') + $t('attributes.name')"
              type="search"
              icon="magnify"
              @input="onFilter"
            ></b-input>
          </b-field>
        </b-field>
      </div>
      <div class="column is-3 is-2-desktop">
        <div class="buttons is-right">
          <b-button
            :loading="isLoading"
            class="is-primary"
            icon-left="plus"
            @click="onAdd"
          >
            <span>
              {{ $t('attributes.add') + $t('attributes.traveler_type') }}
            </span>
          </b-button>
        </div>
      </div>
    </nav>
    <b-table
      :data="items"
      :loading="isLoading"
      :mobile-cards="false"
      hoverable
      narrowed
      bordered
      paginated
      pagination-position="both"
      backend-pagination
      backend-sorting
      :total="total"
      :per-page="perPage"
      :default-sort-direction="defaultSortOrder"
      :default-sort="[sortField, sortOrder]"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      @page-change="onPageChange"
      @sort="onSort"
    >
      <b-table-column
        field="name"
        :label="$t('attributes.name')"
        sortable
        v-slot="props"
      >
        {{ props.row.name }}
      </b-table-column>
      <b-table-column
        field="display_name"
        :label="$t('attributes.display_name')"
        sortable
        v-slot="props"
      >
        {{ props.row.display_name || props.row.name }}
      </b-table-column>
      <b-table-column
        field="traveler_bed_type"
        :label="$t('attributes.traveler_bed_type')"
        :width="250"
        sortable
        v-slot="props"
      >
        {{ bedTypeName(props.row.type) }}
      </b-table-column>
      <b-table-column
        field="age_min"
        :label="$t('attributes.age_min')"
        :width="120"
        centered
        sortable
        v-slot="props"
      >
        {{ props.row.age_min }}
      </b-table-column>
      <b-table-column
        field="age_max"
        :label="$t('attributes.age_max')"
        :width="120"
        centered
        sortable
        v-slot="props"
      >
        {{ props.row.age_max }}
      </b-table-column>
      <b-table-column :width="80" label="功能" centered v-slot="props">
        <div class="buttons">
          <b-button type="is-primary" @click.prevent="onModify(props.row)">
            {{ $t('attributes.modify') }}
          </b-button>
        </div>
      </b-table-column>
    </b-table>
    <b-modal
      :active.sync="isFormModalActive"
      :can-cancel="['escape', 'x']"
      :width="1200"
      has-modal-card
    >
      <traveler-types-form
        @send="onSend"
        :travelerType="selectedItem"
        :isCreate="isCreate"
      >
      </traveler-types-form>
    </b-modal>
  </section>
</template>

<script>
import debounce from 'lodash/debounce'
import { TRAVELER_TYPES_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import TravelerTypesForm from '@/components/mis/TravelerTypesForm'

export default {
  name: 'TravelerTypes',
  components: { TravelerTypesForm },
  data() {
    return {
      isLoading: false,
      sending: false,
      isFormModalActive: false,
      isCreate: false,
      searchName: '',
      total: 0,
      items: [],
      selectedItem: null,

      sortField: 'name',
      sortOrder: 'asc',
      defaultSortOrder: 'asc',
      page: 1,
      perPage: 10
    }
  },
  mounted() {
    this.loadTravelerTypes()
  },
  methods: {
    async loadTravelerTypes() {
      try {
        const api = `${TRAVELER_TYPES_API}`
        const params = {
          name: this.searchName,
          sort_by: this.sortField,
          by_descending: this.sortOrder !== 'asc',
          page_size: this.perPage,
          page_number: this.page
        }
        this.isLoading = true
        const res = await this.axios.get(api, { params })
        const data = res.data.data

        this.items = data.items
        this.total = data.item_count
      } catch (e) {
        this.items = []
        this.total = 0

        notifyService.fetch_error('traveler_type', e)
      } finally {
        this.isLoading = false
      }
    },
    onModify(item) {
      this.selectedItem = item
      this.isCreate = false
      this.isFormModalActive = true
    },
    onAdd() {
      this.selectedItem = {
        id: '',
        age_min: 0,
        age_max: 999,
        name: '',
        display_name: '',
        type: null
      }
      this.isCreate = true
      this.isFormModalActive = true
    },
    async onSend(item) {
      if (this.isCreate) {
        await this.onCreate(item)
      } else {
        await this.onUpdate(item)
      }
    },
    async onCreate(item) {
      try {
        const api = `${TRAVELER_TYPES_API}/create`

        this.sending = true
        await this.axios.post(api, item)
        notifyService.success(this.$t('attributes.add_succeed'))

        await this.loadTravelerTypes()
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
        this.isFormModalActive = false
      }
    },
    async onUpdate(item) {
      try {
        const api = `${TRAVELER_TYPES_API}/update`

        this.sending = true
        await this.axios.put(api, item)
        notifyService.success(this.$t('attributes.update_succeed'))

        await this.loadTravelerTypes()
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
        this.isFormModalActive = false
      }
    },
    onPageChange(page) {
      this.page = page

      this.loadTravelerTypes()
    },
    onSort(field, order) {
      this.sortField = field
      this.sortOrder = order

      this.loadTravelerTypes()
    },
    onFilter: debounce(function() {
      this.loadTravelerTypes()
    }, 500)
  }
}
</script>
